import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Avatar, Skeleton, Icon } from '..';
const Header = _ref => {
  let {
    color,
    dataNameAttribute,
    expanded,
    floatingLabel,
    handleItem,
    headerFlag,
    headerIcon,
    hideIcon,
    hideRightIcon,
    label,
    leftImage,
    loading,
    optionFlagProperty,
    optionTitleKey,
    selected,
    selectedSubValue,
    selectedValue,
    showPlaceholderIcon,
    toggleDropdown,
    type,
    valuePrefix,
    customValue
  } = _ref;
  const [mouseDown, setMouseDown] = useState(false);
  const onMouseDown = () => {
    setMouseDown(true);
  };
  const onMouseUp = () => {
    setMouseDown(false);
  };
  const onFocus = () => {
    if (!mouseDown) {
      toggleDropdown();
    }
  };
  const handleRemoveItem = (e, item) => {
    e.stopPropagation();
    handleItem(item, null, true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(Skeleton, {
    type: "dropdown-form"
  }) : /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'wrts-dropdown-form': type === 'form',
      'wrts-dropdown-simple': type === 'simple',
      'wrts-dropdown-form multi': type === 'multi',
      'hide-label': type === 'multi' ? selectedValue && selectedValue.length : !floatingLabel && selectedValue,
      'light-grey': color === 'grey',
      selected
    }),
    "data-name": dataNameAttribute,
    onClick: toggleDropdown,
    onFocus: onFocus,
    onMouseUp: onMouseUp,
    onMouseDown: onMouseDown,
    tabIndex: 0
  }, type === 'multi' ? selectedValue && selectedValue.length ? selectedValue.map(item => /*#__PURE__*/React.createElement("div", {
    className: "multi-item",
    key: item[optionTitleKey]
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, item[optionTitleKey]), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "remove-btn",
    onClick: e => handleRemoveItem(e, item)
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close"
  })))) : /*#__PURE__*/React.createElement("span", {
    className: "label"
  }, label) : customValue ? customValue : /*#__PURE__*/React.createElement(React.Fragment, null, !hideIcon && /*#__PURE__*/React.createElement(React.Fragment, null, leftImage && !headerIcon && !headerFlag && /*#__PURE__*/React.createElement(Avatar, {
    image: leftImage,
    classNameWrap: "left-icon"
  }), headerIcon && /*#__PURE__*/React.createElement(Icon, {
    name: headerIcon,
    className: "left-icon"
  }), (headerFlag || !selectedValue && showPlaceholderIcon) && /*#__PURE__*/React.createElement("span", {
    className: classNames(optionFlagProperty, `${optionFlagProperty}-${headerFlag}`, 'left-icon', {
      'placeholder-icon': !selectedValue && showPlaceholderIcon
    })
  })), valuePrefix && /*#__PURE__*/React.createElement("span", {
    className: "title value-prefix hide-xs"
  }, valuePrefix), selectedValue && /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, selectedValue), selectedSubValue && /*#__PURE__*/React.createElement("span", {
    className: "title sub-title"
  }, selectedSubValue), /*#__PURE__*/React.createElement("span", {
    className: classNames('label', {
      active: selectedValue
    })
  }, label)), /*#__PURE__*/React.createElement(Icon, {
    name: !hideRightIcon ? 'expand-more' : '',
    className: classNames('right-icon', {
      expanded
    })
  })));
};
Header.defaultProps = {
  expanded: false,
  showHeaderIcon: true,
  floatingLabel: false,
  hideIcon: false
};
Header.propTypes = {
  color: PropTypes.string,
  expanded: PropTypes.bool,
  headerIcon: PropTypes.string,
  showHeaderIcon: PropTypes.bool,
  toggleDropdown: PropTypes.func,
  floatingLabel: PropTypes.bool,
  valuePrefix: PropTypes.string
};
export default Header;